import {
  CheckIcon,
  ClipboardDocumentListIcon,
  MinusIcon,
  PlusIcon,
} from "@heroicons/react/24/outline";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

/**
 * Bulk-action bar when one or more My Vendors cards are selected.
 */
export default function MyVendorsSelectionBar({
  selectedVendors = [],
  allSelected = false,
  onSelectAll,
  onRemoveVendor,
  onCreateList,
  onAddToList,
  onCompare,
  showCompare = true,
  showListActions = true,
  showRemoveSelected = false,
  onRemoveSelected,
  className = "",
}) {
  if (!selectedVendors.length) return null;

  return (
    <div
      className={classNames(
        "mb-4 flex min-h-[40px] w-full min-w-0 items-center gap-3",
        className
      )}
    >
      <button
        type="button"
        onClick={onSelectAll}
        className="inline-flex flex-shrink-0 items-center gap-2 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      >
        {allSelected ? (
          <MinusIcon className="h-4 w-4 text-gray-500" aria-hidden="true" />
        ) : (
          <CheckIcon className="h-4 w-4 text-gray-500" aria-hidden="true" />
        )}
        {allSelected ? "Deselect All" : "Select All"}
      </button>

      {showListActions ? (
        <>
          <button
            type="button"
            onClick={onCreateList}
            className="inline-flex flex-shrink-0 items-center gap-2 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-50"
          >
            <PlusIcon className="h-4 w-4" aria-hidden="true" />
            Create List
          </button>
          <button
            type="button"
            onClick={onAddToList}
            className="inline-flex flex-shrink-0 items-center gap-2 rounded-md border border-gray-300 bg-white px-3 py-2 text-sm font-semibold text-gray-700 shadow-sm hover:bg-gray-50"
          >
            <ClipboardDocumentListIcon className="h-4 w-4" aria-hidden="true" />
            Add to List
          </button>
        </>
      ) : null}

      {showRemoveSelected ? (
        <button
          type="button"
          onClick={onRemoveSelected}
          className="inline-flex flex-shrink-0 items-center gap-2 rounded-md border border-red-300 bg-white px-3 py-2 text-sm font-semibold text-red-700 shadow-sm hover:bg-red-50"
        >
          Remove
        </button>
      ) : null}

      {showCompare ? (
        <button
          type="button"
          onClick={onCompare}
          className="inline-flex flex-shrink-0 items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Compare
        </button>
      ) : null}

      <div className="flex h-[40px] min-w-0 flex-1 items-center overflow-x-auto">
        <div className="flex flex-nowrap items-center gap-2">
          {selectedVendors.map((vendor) => (
            <span
              key={vendor.id}
              className="inline-flex flex-shrink-0 items-center gap-x-1.5 whitespace-nowrap rounded-md bg-indigo-600 px-2 py-1 text-xs font-medium text-white ring-1 ring-indigo-600"
            >
              {vendor.name}
              <button
                type="button"
                className="group relative -mr-1 ml-1 h-3.5 w-3.5 rounded-sm hover:bg-indigo-800/20"
                onClick={() => onRemoveVendor?.(vendor)}
                aria-label={`Remove ${vendor.name}`}
              >
                <svg viewBox="0 0 14 14" className="h-3.5 w-3.5 stroke-current" aria-hidden="true">
                  <path d="M4 4l6 6m0-6l-6 6" />
                </svg>
              </button>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
